import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

// Layouts
import LayoutPublic from "@/layouts/LayoutPublic.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "publicPositions",
    meta: { layout: LayoutPublic },
    component: () => import("@/features/public/views/PositionsView.vue"),
  },
  {
    path: "/:id?_:slug?",
    name: "publicPosition",
    meta: { layout: LayoutPublic },
    component: () => import("@/features/public/views/PositionView.vue"),
  },
  {
    path: "/:id?_:slug?/apply",
    name: "publicPositionApply",
    meta: { layout: LayoutPublic },
    component: () => import("@/features/public/views/PositionApplyView.vue"),
  },

  {
    path: "/positions/:id", // This is the old route, but it's still in use by some customers
    name: "oldPublicPosition",
    meta: { layout: LayoutPublic },
    component: () => import("@/features/public/views/PositionView.vue"),
  },
  {
    path: "/positions/:id/apply", // This is the old route, but it's still in use by some customers
    name: "oldPublicPositionApply",
    meta: { layout: LayoutPublic },
    component: () => import("@/features/public/views/PositionApplyView.vue"),
  },

  // {
  //   path: "/positions",
  //   name: "publicPositions",
  //   meta: { layout: LayoutPublic },
  //   component: () => import("@/features/positions/views/PositionsView.vue"),
  // },

  {
    path: "/:id?_:slug?/apply",
    name: "publicPositionApply",
    meta: { layout: LayoutPublic },
    component: () => import("@/features/public/views/PositionApplyView.vue"),
  },
  {
    path: "/internal/:guid",
    name: "internalPosition1",
    meta: { layout: LayoutPublic },
    component: () => import("@/features/public/views/PositionView.vue"),
  },
  {
    path: "/internal/:guid/apply",
    name: "internalPositionApply1",
    meta: { layout: LayoutPublic },
    component: () => import("@/features/public/views/PositionApplyView.vue"),
  },
  {
    path: "/internal-positions/:guid",
    name: "internalPosition",
    meta: { layout: LayoutPublic },
    component: () => import("@/features/public/views/PositionView.vue"),
  },
  {
    path: "/internal-positions/:guid/apply",
    name: "internalPositionApply",
    meta: { layout: LayoutPublic },
    component: () => import("@/features/public/views/PositionApplyView.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    meta: { layout: LayoutPublic },
    component: () => import("../features/shared/views/NotFoundView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
